import React, {Component} from 'react';
import {Drawer, Typography, Paper, ListItem, MenuItem} from '@material-ui/core/';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './store/actions/index';
import QuickPanelContent from './QuickPanelContent';
import ProfilPanel from './ProfilPanel';
import history from '../../history';

const styles = theme => ({
    root: {
        width  : 280,
        padding: 10
    }
});

class QuickPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: (<QuickPanelContent />)
        };
        // console.log(localStorage.getItem('jwt_token').length);

        if(localStorage.getItem('user').length > 0){
            this.state.content = (<ProfilPanel />);
        }
    }

    gotoTautan = (tautan) => (e) => {
        history.push(tautan);
    }

    render()
    {
        const {classes, state, toggleQuickPanel} = this.props;
        // const {content} = this.state;

        return (
            <Drawer
                classes={{paper: classes.root}}
                open={state}
                anchor="right"
                onClose={() => toggleQuickPanel(false)}
            >
                {/* <Typography>Panel untuk profil pengguna termasuk login/logout</Typography> */}
                {this.state.content}

                <Paper className="p-8">
                    <Typography variant="subheading" className="p-8">
                        Notifikasi
                    </Typography>
                    {this.props.notifikasi_kecil.rows.map((option)=>{
                        return (
                            <ListItem onClick={this.gotoTautan(option.tautan)} style={{borderRadius:'0px',borderBottom: '1px solid #ccc'}} elevation={0} button className="p-8 border-b-1 border-gray-200">
                                <Typography variant="caption">
                                    {option.keterangan}
                                    <br/>
                                    <b>{option.create_date}</b>
                                </Typography>
                            </ListItem>
                        )
                    })}
                    <MenuItem button className="p-8" onClick={()=>history.push('/Notifikasi')} style={{textAlign:'center', fontStyle: 'italic', background:'#eeeeee', fontSize:'12px'}}>
                        Selengkapnya
                    </MenuItem>
                </Paper>
            </Drawer>
        );
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        toggleQuickPanel: Actions.toggleQuickPanel
    }, dispatch);
}

function mapStateToProps({quickPanel, App})
{
    return {
        state: quickPanel.state,
        notifikasi: App.notifikasi,
        notifikasi_kecil: App.notifikasi_kecil,
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(QuickPanel));



// WEBPACK FOOTER //
// ./src/main/quickPanel/QuickPanel.js